import { mergeStyles } from "office-ui-fabric-react";

export const dropDownS = mergeStyles({
    marginBottom: 15
  })